import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export const initialLoading = {
  retrieve: false,
  signin: false,
  signout: false,
  reset_pass: false,
  check_link: false,
  check_email: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>

export type Session = {
  id: string,
  role: "admin" | "operator" | "client",
  token: string
}

const initialState: { value: Session | null, isLoading: IsLoading } = {
  value: null, isLoading: initialLoading
}

const sessionSlice = createSlice({
  name: "session_slice",
  initialState,
  reducers: {
    signin: (state, action: PayloadAction<Session>) => {
      state.value = action.payload
    },
    signout: (state) => {
      state.value = null
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const session_slice = sessionSlice.reducer
export const { signin, signout, setLoading } = sessionSlice.actions